//node-modules
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import {
  createContext,
  useEffect,
  useRef,
  useState,
  useContext,
  Dispatch,
  SetStateAction,
} from "react";
import { useTranslation } from "react-i18next";
import axios, { AxiosResponse } from "axios";
//common
import { Common } from "../../common/src/index";
// css
import "../../css/buttonTheme.css";
//src
import NavBar from "../components/NavBar";
import PointCloudViewer from "../components/ProjectDetail/PointCloudViewer";
import Photos from "../components/ProjectDetail/Photos";
import { MsgSnackbar } from "../components/MsgSnackbar";
import { MsgErrSnackbar } from "../components/MsgErrSnackbar";
import ProjectState from "../components/ProjectDetail/projectState";
import { Viewer } from "../viewer/viewer";
import { config } from "../config/config";
import "../locales/i18n";
import { TProjectionMode } from "../viewer/utils/camera-utils";
// mui
import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  Fade,
  useTheme,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import AlignmentIcon from "../../images/icons/white_edit/DocumentExport_white.svg";

import RegisterWithDashboard from "../components/ProjectDetail/Dialogs/RegisterWithDashboard";
import RegisterWithLLV from "../components/ProjectDetail/Dialogs/RegisterWIthLLV";
import RegisterWithPointworks from "../components/ProjectDetail/Dialogs/RegisterWithPointworks";
import ProjectDetailDialog from "../components/ProjectDetail/Dialogs/ProjectDetailDialog";
import ExportData from "../components/ProjectDetail/Dialogs/ExportDataDialog";
import MsgWarnSnackbar from "../components/MsgWarnSnackbar";
import { userSetting } from "../../common/src/modules";
import { useThemeMode } from "../..";
import { MenuBar } from "../components/ProjectDetail/MenuBar/MenuBar";
import { ToolBar } from "../components/ProjectDetail/ToolBar/ToolBar";
import { Q3DBottomDrawer } from "../components/ProjectDetail/BottomDrawer/Q3DBottomDrawer";
import { HelmContextProvider } from "../components/ProjectDetail/Contexts/HelmContext";
import CalcContext, {
  CalcContextProvider,
} from "../components/ProjectDetail/Contexts/CalcContext";
import SettingDialog from "../components/Home/SettingDialog";
import DeleteProjectDialog from "../components/DeleteProjectDialog";
import DeleteAllPointsDialog from "../components/ProjectDetail/Dialogs/DeleteAllPointsDialog";
import { CoordinateContextProvider } from "../components/ProjectDetail/Contexts/CoordinateContext";
import ProcessCompletedDialog from "../components/ProcessCompletedDialog";
import { UpdateInfoContextProvider } from "../components/ProjectDetail/Contexts/UpdateInfoContext";
import { RemoveContextProvider } from "../components/ProjectDetail/Contexts/RemoveContext";
import {
  DETAIL_TAB,
  EDialogType,
  EDisplayType,
  EViewerMode,
  GAObj,
  IEnabledUpdateProjectDetail,
  LoadingStatus,
  PollingContext,
  PollingIds,
  PROCESS,
  ProcessIds,
  ProcessResult,
  ProjectDetailContext,
  resErrCode,
  RESULT,
  TProjectDetailContext,
  UseSnackbarContext,
} from "../components/ProjectDetail/Interfaces/ProjectDetailInterfaces";
import { ViewerContext } from "../viewer/context";

const viewer = new Viewer();

interface Props {
  displayType: EDisplayType;
}

let timer: NodeJS.Timeout = null;

const ProjectDetail = ({ displayType }: Props) => {
  // プロジェクトIDを取得
  const { projectId } = useParams();
  const navigate = useNavigate();

  // search condition from Home
  const location = useLocation();

  // 多言語対応
  const { t, i18n } = useTranslation();

  const pointCloudViewerRef = useRef<any>();

  /*****************************************
   context
  ******************************************/
  const {} = useContext(CalcContext);

  /*****************************************
   state
  ******************************************/
  // value
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [pollingCallback, setPollingCallback] = useState<() => void>(
    () => () => {},
  );
  const [projectDetail, setProjectDetail] = useState<Common.ProjectDetail>(); // プロジェクト詳細情報
  const [processIds, setProcessIds] = useState<ProcessIds>({
    sfm: null,
    helmert: null,
  } as ProcessIds);
  const [userSettings, setUserSettings] = useState<Common.userSetting>();
  const [projectName, setProjectName] = useState<string>("");
  const [GAValue, setGAValue] = useState<GAObj>({
    jobsiteId: null,
    userId: null,
    corporationId: null,
  } as GAObj);
  const [userInfo, setUserInfo] = useState<Common.LandlogNecessaryUserInfo>();

  // snackbar
  const [openSuccess, setOpenSuccess] = useState<boolean>(false); // Success snackbar
  const [msgSuccess, setMsgSuccess] = useState<string>(""); // Success snackbar
  const [openWarnig, setOpenWarning] = useState<boolean>(false); // Warning snackbar
  const [msgWarning, setMsgWarning] = useState<string>(""); // Warning snackbar
  const [openError, setOpenError] = useState<boolean>(false); // Error snackbar
  const [msgError, setMsgError] = useState<string>(""); // Error snackbar

  // UI
  const [initDone, setInitDone] = useState<boolean>(false); // 画面初期化 or 強制初期化
  const [isJapanese, setIsJapanese] = useState<boolean>(false); // language is japanese?
  const [currentPointCloud, setCurrentPointCloud] =
    useState<Common.POINT_CLOUD_TYPE>(); // current point cloud type
  const [detailTab, setDetailTab] = useState<DETAIL_TAB>(); // current point cloud Tab
  const [whilePointCloudLoading, setWhilePointCloudLoading] =
    useState<boolean>(false);
  const [openProjectState, setOpenProjectState] = useState<boolean>(false); // project state
  const [toolBarShow, setToolBarShow] = useState<boolean>(true); // toolbox
  const [detailDataLoadingStatus, setDetailDataLoadingStatus] =
    useState<LoadingStatus>(LoadingStatus.Loading); // loading status
  const [errorDetailsStatus, setErrorDetailsStatus] = useState<number>(); // error status
  const [pix4dErrorMessage, setPix4dErrorMessage] = useState<string>(); // error code
  const [pix4dErrorCode, setPix4dErrorCode] = useState<number>(); // error code
  const { themeMode, setThemeMode } = useThemeMode();

  // test
  const [bottomOpen, setBottomOpen] = useState(true);
  const headerHeight = "40px";
  const menubarHeight = "56px";
  const toolbarHeight = "48px";
  const viewerHeight = `calc(100vh - ${
    displayType === EDisplayType.Web ? headerHeight : "0px"
  } - ${menubarHeight} - ${toolbarHeight})`;

  const isIosView =
    window.location.pathname.includes("/ios/") ||
    window.location.pathname.includes("/ios-ar/");
  const isArView =
    window.location.pathname.includes("/ar/") ||
    window.location.pathname.includes("/ios-ar/");

  // mode

  const [currentViewerMode, setCurrentViewerMode] = useState<EViewerMode>(
    EViewerMode.DEFAULT,
  ); // 計測/座標変換/点群除去/エクスポート

  const [currentDialog, setCurrentDialog] = useState<EDialogType>(
    EDialogType.NONE,
  ); // dialog

  // current projection
  // usersettings更新APIする前のもの
  const [projectionPoint, setProjectionPoint] = useState<boolean>();
  const [projectionDefault, setProjectionDefault] = useState<boolean>();

  const [processResult, setProcessResult] = useState<ProcessResult>({
    id: null,
    process: null,
    result: null,
  } as ProcessResult);
  const [openProcessCompletedDialog, setOpenProcessCompletedDialog] =
    useState<boolean>(false);
  const pollingIdsRef = useRef<PollingIds>({
    sfm: null,
    helmert: null,
  } as PollingIds);

  /*****************************************
   Effect
   ******************************************/
  useEffect(() => {
    setIsJapanese(i18n.language === "ja");
  }, [i18n.language]);

  useEffect(() => {
    const abortController = new AbortController();

    if (processIds.sfm) {
      pollingIdsRef.current.sfm = window.setInterval(() => {
        let hostName = config.serverHost.includes("localhost")
          ? "http://localhost:9090/quick3d"
          : config.serverHost;
        const url = `${hostName}/project_${projectId}/history/${processIds.sfm}.process`;

        axios
          .get(url, {
            responseType: "json",
            signal: abortController.signal,
          })
          .then((response) => {
            const jsonData = response?.data;

            const id: string = processIds.sfm;
            const result: RESULT = jsonData.result;
            const process: PROCESS = jsonData.process;
            setProcessResult({ id, process, result });
            setOpenProcessCompletedDialog(true);
            window.clearInterval(pollingIdsRef.current.sfm);
          })
          .catch((err) => {
            // console.log(err);
          });
      }, 10000); // 10s
    }

    if (processIds.helmert) {
      pollingIdsRef.current.helmert = window.setInterval(() => {
        let hostName = config.serverHost.includes("localhost")
          ? "http://localhost:9090/quick3d"
          : config.serverHost;
        const url = `${hostName}/project_${projectId}/history/${processIds.helmert}.process`;

        axios
          .get(url, {
            responseType: "json",
            signal: abortController.signal,
          })
          .then((response) => {
            const jsonData = response?.data;

            const id: string = processIds.helmert;
            const result: RESULT = jsonData.result;
            const process: PROCESS = jsonData.process;
            setProcessResult({ id, process, result });
            setOpenProcessCompletedDialog(true);
            window.clearInterval(pollingIdsRef.current.helmert);
            getProjectDetail();
          })
          .catch((err) => {
            // console.log(err);
          });
      }, 10000); // 10s
    }

    return () => {
      window.clearInterval(pollingIdsRef.current.sfm);
      window.clearInterval(pollingIdsRef.current.helmert);
    };
  }, [processIds]);

  // useEffect(() => {
  //   const showBottomDrawer =
  //     bottomOpen &&
  //     (currentViewerMode === EViewerMode.CALCULATION ||
  //       currentViewerMode === EViewerMode.HELMERT_TRANSFORM);
  //   showBottomDrawer ? setBottomHeight("150px") : setBottomHeight("0px");
  // }, [currentViewerMode]);

  // init/force reload
  useEffect(() => {
    if (initDone) return;
    try {
      if (config.licenseCheck) {
        axios
          .get(`${config.serverHost}/api/v1/user/licenses`, {
            withCredentials: true,
          })
          .then((response) => {
            const landlogLicenseStatus: Common.LandlogLicenseStatus =
              response.data;
            const numOfLicenses = landlogLicenseStatus.numOfLicenses;

            if (config.licenseCheck) {
              if (0 < numOfLicenses) {
                getProjectCookie().then(() => {
                  Promise.all([
                    getProjectDetail(),
                    getUserSettings(true),
                    getUserInfo(),
                  ]);
                });
              } else {
                openErrorSnackbar(t("LICENSE_ERROR"));
                setTimeout(function () {
                  window.location.href = `${config.serverHost}/login?displayType=web`;
                }, 2000);
              }
            }
          })
          .catch((err) => {
            openErrorSnackbar(t("LICENSE_ERROR"));
            setTimeout(function () {
              window.location.href = `${config.serverHost}/login?displayType=web`;
            }, 2000);
          });
      } else {
        getProjectCookie().then(() => {
          Promise.all([
            getProjectDetail(),
            getUserSettings(true),
            getUserInfo(),
          ]);
        });
      }
    } catch {
    } finally {
      setInitDone(true);
    }
  }, [initDone]);

  useEffect(() => {
    const { dataLayer } = window;

    const areAllNotNull = (obj: Object) => {
      return Object.values(obj).every((value) => value !== null);
    };

    if (areAllNotNull(GAValue)) {
      dataLayer.push({
        event: "sc_jobsite_open", // イベント名
        sc_site_id: GAValue?.jobsiteId,
        sc_user_id: GAValue?.userId,
        sc_corporation_id: GAValue?.corporationId,
      });
    }
  }, [GAValue]);

  useEffect(() => {
    viewer.Resize();
  }, [bottomOpen]);

  const [projectionMode, setProjectionMode] = useState<TProjectionMode>(
    userSettings?.projectionDefault ? "perspective" : "orthographic",
  );

  useEffect(() => {
    setProjectionMode(
      userSettings?.projectionDefault ? "perspective" : "orthographic",
    );
  }, [userSettings]);

  useEffect(() => {
    if (!viewer) return;

    if (viewer.isCameraInit()) viewer.setProjectionMode(projectionMode);
  }, [projectionMode, viewer.isCameraInit()]);

  const updateProjectionPoint = (isPerspective: boolean) => {
    try {
      if (
        currentViewerMode === EViewerMode.CALCULATION ||
        currentViewerMode === EViewerMode.HELMERT_TRANSFORM ||
        currentViewerMode === EViewerMode.POINT_REMOVE
      ) {
        viewer.setProjectionMode(
          isPerspective ? "perspective" : "orthographic",
        );
        setProjectionPoint(isPerspective);
      }
    } catch {}
  };

  const updateProjectionDefault = (isPerspective: boolean) => {
    try {
      if (
        !(
          currentViewerMode === EViewerMode.CALCULATION ||
          currentViewerMode === EViewerMode.HELMERT_TRANSFORM ||
          currentViewerMode === EViewerMode.POINT_REMOVE
        )
      ) {
        viewer.setProjectionMode(
          isPerspective ? "perspective" : "orthographic",
        );
        setProjectionDefault(isPerspective);
      }
    } catch {}
  };

  useEffect(() => {
    try {
      viewer?.Resize();
    } catch {}
  }, [toolBarShow]);

  useEffect(() => {
    if (isInitialized) return;

    // if (detailTab === DETAIL_TAB.PHOTO) return;

    if (projectDetail) {
      if (
        projectDetail.status.helmert_transformation ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        projectDetail.status.verification_helmert ===
          Common.PROJECT_STATUS_ENUM.COMPLETED
      ) {
        setCurrentPointCloud(Common.POINT_CLOUD_TYPE.HELMERT);
        setDetailTab(DETAIL_TAB.HELMERT);
      } else if (
        projectDetail.status.sfm_processing ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        projectDetail.status.verification_sfm ===
          Common.PROJECT_STATUS_ENUM.COMPLETED
      ) {
        setCurrentPointCloud(Common.POINT_CLOUD_TYPE.SFM);
        setDetailTab(DETAIL_TAB.SFM);
      } else {
        setCurrentPointCloud(Common.POINT_CLOUD_TYPE.SIMPLE);
        setDetailTab(DETAIL_TAB.SIMPLE);
      }

      setIsInitialized(true);
    }
  }, [projectDetail]);

  useEffect(() => {
    if (projectDetail) {
      const apiUrl = `${config.serverHost}/api/v1/user/setting`;
      axios
        .get(apiUrl, { withCredentials: true })
        .then((res: AxiosResponse<any>) => {
          if (res.data && res.data.pointCloudBgcolor !== null) {
            viewer.setBackgroundColor(
              res.data.pointCloudBgcolor,
              res.data.pointCloudBgalpha,
            );
          }
        })
        .catch((e) => {
          console.error(e);
          return undefined;
        });
    }
  }, [projectDetail]);

  useEffect(() => {
    if (viewer && userSettings?.pointCloudBgcolor) {
      const colorHex = userSettings.pointCloudBgcolor;
      const alpha = userSettings.pointCloudBgalpha ?? 1;
      const colorInt = parseInt(colorHex.substring(1), 16);

      viewer.setBackgroundColor(colorInt, alpha);
    }
  }, [viewer, userSettings, detailTab]);

  useEffect(() => {
    return () => {
      console.log("unmount");
      setIsInitialized(false);
    };
  }, []);

  /*****************************************
  function
  ******************************************/
  const updateOpenProcessCompletedDialog = (flag: boolean) => {
    setOpenProcessCompletedDialog(flag);
  };

  const closeProcessCompletedDialog = () => {
    updateOpenProcessCompletedDialog(false);
  };

  const updateProcessIds = (processIds: ProcessIds) => {
    setProcessIds(processIds);
  };

  const reloadPointCloud = () => {
    pointCloudViewerRef?.current?.reloadPointCloud();
  };

  // プロジェクト詳細更新
  const updateProjectDetail = (newDetail: IEnabledUpdateProjectDetail) => {
    if (newDetail.name) {
      setProjectName(newDetail.name);
      document.title = newDetail.name;
    }
    setProjectDetail((prev) => {
      return {
        ...prev,
        name: newDetail.name ? newDetail.name : prev.name,
        status: {
          ...prev.status,
          helmert_transformation: newDetail.helmert_transformation
            ? newDetail.helmert_transformation
            : prev.status.helmert_transformation,
          coordinate_transformation: newDetail.coordinate_transformation
            ? newDetail.coordinate_transformation
            : prev.status.coordinate_transformation,
          point_splitting_lidar: newDetail.point_splitting_lidar
            ? newDetail.point_splitting_lidar
            : prev.status.point_splitting_lidar,
          point_splitting_sfm: newDetail.point_splitting_sfm
            ? newDetail.point_splitting_sfm
            : prev.status.point_splitting_sfm,
          point_splitting_helmert: newDetail.point_splitting_helmert
            ? newDetail.point_splitting_helmert
            : prev.status.point_splitting_helmert,
          remove_lidar: newDetail.remove_lidar
            ? newDetail.remove_lidar
            : prev.status.remove_lidar,
          remove_sfm: newDetail.remove_sfm
            ? newDetail.remove_sfm
            : prev.status.remove_sfm,
          remove_helmert: newDetail.remove_helmert
            ? newDetail.remove_helmert
            : prev.status.remove_helmert,
          point_txt_lidar: newDetail.point_txt_lidar
            ? newDetail.point_txt_lidar
            : prev.status.point_txt_lidar,
          point_txt_sfm: newDetail.point_txt_sfm
            ? newDetail.point_txt_sfm
            : prev.status.point_txt_sfm,
          point_txt_helmert: newDetail.point_txt_helmert
            ? newDetail.point_txt_helmert
            : prev.status.point_txt_helmert,
        },
        ifc_file:
          newDetail.ifc_file || newDetail.ifc_file === null
            ? newDetail.ifc_file
            : prev.ifc_file,
        design_file:
          newDetail.design_file || newDetail.design_file === null
            ? newDetail.design_file
            : prev.design_file,
      };
    });
  };

  // View変更
  // const setProjectDetailPageView = (newViewType: EViewerMode) => {
  //   if (newViewType === currentViewerMode) return;

  //   setCurrentViewerMode(newViewType);
  //   setOpenProjectState(newViewType === EViewerMode.DEFAULT);
  // };

  // 点群変更
  const updateCurrentPointCloud = (newType: Common.POINT_CLOUD_TYPE) => {
    setCurrentPointCloud(newType);
    // const tab = POINT_CLOUD_TYPE2DETAIL_TAB(newType);
    // tab && setDetailTab(tab);
  };

  // タブ変更
  // const onChangeCurrentPointCloud = (newValue: DETAIL_TAB) => {
  //   if (currentViewerMode === EViewerMode.POINT_REMOVE) {
  //     updateCurrentDialog(EDialogType.POINT_REMOVE);
  //     return;
  //   }
  //   if (currentViewerMode === EViewerMode.PHOTO)
  //     setCurrentViewerMode(EViewerMode.DEFAULT);

  //   if (currentViewerMode === EViewerMode.CALCULATION)
  //     // changeCalculationMode(ECalculationMode.CREATING);
  //     setDetailTab(newValue);
  //   clearTimeout(timer);
  //   timer = setTimeout(() => {
  //     setCurrentPointCloud(DETAIL_TAB2POINT_CLOUD_TYPE(newValue));
  //   }, 300);
  // };

  // 座標変換ボタン
  // const handleOpenCoordinateTransformParent = () => {
  //   if (currentViewerMode === EViewerMode.HELMERT_TRANSFORM) {
  //     updateCurrentViewerMode(EViewerMode.DEFAULT);
  //   } else {
  //     setCurrentViewerMode(EViewerMode.HELMERT_TRANSFORM);
  //     setOpenProjectState(false);
  //   }
  // };

  // const disabledCoordinate = () => {
  //   if (showCalcMenu || currentViewerMode === EViewerMode.CALCULATION) {
  //     return true;
  //   }
  //   if (currentViewerMode === EViewerMode.POINT_REMOVE) {
  //     return true;
  //   }
  //   if (currentViewerMode === EViewerMode.PHOTO) {
  //     return true;
  //   }
  //   if (currentViewerMode === EViewerMode.EXPORT_TO_OTHER) {
  //     return true;
  //   }
  //   return false;
  // };

  // データ登録ボタン
  // const toggleExportToOherService = () => {
  //   if (currentViewerMode === EViewerMode.EXPORT_TO_OTHER) {
  //     updateCurrentViewerMode(EViewerMode.DEFAULT);
  //     updateCurrentDialog(EDialogType.NONE);
  //   } else {
  //     updateCurrentViewerMode(EViewerMode.EXPORT_TO_OTHER);
  //   }
  // };

  // const disabledAlignmentDialog = () => {
  //   if (showCalcMenu || currentViewerMode === EViewerMode.CALCULATION) {
  //     return true;
  //   }
  //   if (currentViewerMode === EViewerMode.POINT_REMOVE) {
  //     return true;
  //   }
  //   if (currentViewerMode === EViewerMode.PHOTO) {
  //     return true;
  //   }
  //   return false;
  // };

  // // ツールボックスボタン
  // const handleShowToolBar = () => {
  //   setToolBarShow((prev) => !prev);
  // };

  // const disabledToolBar = () => {
  //   return whilePointCloudLoading || currentViewerMode === EViewerMode.PHOTO;
  // };

  // 簡易点群除去ボタン
  type CustomIconProps = {
    path: string;
    disabled: boolean;
  };

  // const CustomIcon: FC<CustomIconProps> = ({ path, disabled }) => {
  //   return (
  //     <ToolIcon
  //       imagePath={path}
  //       color={disabled ? "gray" : customColor.color}
  //     />
  //   );
  // };

  // const startPointRemoveMode = () => {
  //   if (currentViewerMode !== EViewerMode.POINT_REMOVE) {
  //     viewer.poligonIndicesCount = 0;
  //   }
  //   updateCurrentViewerMode(EViewerMode.POINT_REMOVE);
  // };

  // const disabledPointRemove = () => {
  //   // if (displayType === EDisplayType.iOS) { return true; }
  //   if (currentPointCloud === Common.POINT_CLOUD_TYPE.SIMPLE) {
  //     return true;
  //   }
  //   if (whilePointCloudLoading) {
  //     return true;
  //   }
  //   if (showCalcMenu || currentViewerMode === EViewerMode.CALCULATION) {
  //     return true;
  //   }
  //   if (currentViewerMode === EViewerMode.PHOTO) {
  //     return true;
  //   }
  //   if (currentViewerMode === EViewerMode.EXPORT_TO_OTHER) {
  //     return true;
  //   }
  //   return false;
  // };

  // const disabledCalculation = () => {
  //   if (whilePointCloudLoading) {
  //     return true;
  //   }
  //   if (currentViewerMode === EViewerMode.POINT_REMOVE) {
  //     return true;
  //   }
  //   if (currentViewerMode === EViewerMode.PHOTO) {
  //     return true;
  //   }
  //   if (currentViewerMode === EViewerMode.EXPORT_TO_OTHER) {
  //     return true;
  //   }
  //   return false;
  // };

  // // プロジェクトメニューボタン
  // const handleShowMenu = (event: any) => {
  //   setMenuAnchorEl(event.currentTarget);
  // };

  // const disabledMenu = () => {
  //   return (
  //     whilePointCloudLoading ||
  //     currentViewerMode === EViewerMode.CALCULATION ||
  //     currentViewerMode === EViewerMode.POINT_REMOVE
  //   );
  // };

  // プロジェクトステータス表示
  const toggleProjectState = (newVal?: boolean) => {
    newVal !== undefined || newVal != null
      ? setOpenProjectState(newVal)
      : setOpenProjectState((prev) => !prev);
  };

  // ビューモード変更
  const updateCurrentViewerMode = (newVal: EViewerMode) => {
    setCurrentViewerMode(newVal);
  };

  // // 計算ステータス変更
  // const changeCalculationMode = (mode: ECalculationMode) => {
  //   setCalculationMode(mode);
  // };

  // ダイアログ表示
  const updateCurrentDialog = (name: EDialogType) => {
    setCurrentDialog(name);
  };

  const updateWhilePointCloudLoading = (val: boolean) => {
    setWhilePointCloudLoading(val);
  };

  const getProjectCookie = async () => {
    const abortController = new AbortController();

    try {
      await axios.get(
        `${config.serverHost}/api/v1/project/${projectId}/cookie`,
        {
          withCredentials: true,
          signal: abortController.signal,
        },
      );
    } catch (err) {
      // console.log(err);
    }
  };

  const forceBackToHome = () => {
    const search = sessionStorage.getItem("search");

    if (search) {
      const params = new URLSearchParams(search);
      navigate(`/?${params.toString()}`);
    } else {
      navigate("/");
    }
  };
  // projectDetail from /api/v1/project/{projectId}
  const getProjectDetail = async (shouldSetProcessIds?: boolean) => {
    try {
      await axios
        .get(`${config.serverHost}/api/v1/project/${projectId}`, {
          withCredentials: true,
        })
        .then((res: AxiosResponse<Common.ProjectDetail>) => {
          setProjectDetail(res.data);

          if (res.data?.status?.is_ar && !isArView) forceBackToHome();

          if (shouldSetProcessIds !== false) {
            setProcessIds({
              sfm: res.data.sfmProcessId,
              helmert: res.data.helmertProcessId,
            } as ProcessIds);
          }

          setProjectName(res?.data?.name);
          setGAValue(
            (prev) => ({ ...prev, jobsiteId: res?.data?.jobsiteId }) as GAObj,
          );
          document.title = res.data.name;
          setDetailDataLoadingStatus(LoadingStatus.Loaded); // loaded detail data -> show detail page
          setPix4dErrorMessage(res.data.pix4dErrorMessage);
          setPix4dErrorCode(res.data.pix4dErrorCode);
        })
        .catch((err) => {
          setErrorDetailsStatus(
            err.response?.status === resErrCode.Authority
              ? resErrCode.Authority
              : resErrCode.NotFound,
          );
          setDetailDataLoadingStatus(LoadingStatus.Error);
        });
    } catch (err) {
      setDetailDataLoadingStatus(LoadingStatus.Error);
    }
  };

  const getUserInfo = async () => {
    let apiUrl = `${config.serverHost}/api/v1/user`;
    await axios
      .get(apiUrl, { withCredentials: true })
      .then((res: AxiosResponse<Common.LandlogNecessaryUserInfo>) => {
        setUserInfo(res.data);
        setGAValue(
          (prev) =>
            ({
              ...prev,
              userId: res?.data?.userId,
              corporationId: res?.data?.corporationId,
            }) as GAObj,
        );
      });
  };

  const getUserSettings = async (shouldSetTheme: boolean = false) => {
    const apiUrl = `${config.serverHost}/api/v1/user/setting`;
    await axios
      .get(apiUrl, { withCredentials: true })
      .then((res: AxiosResponse<any>) => {
        setUserSettings(res.data);
        const projection = (res.data as userSetting)?.projectionDefault
          ? "perspective"
          : "orthographic";
        viewer.setProjectionMode(projection);

        setProjectionPoint(res.data.projectionPoint);
        setProjectionDefault(res.data.projectionDefault);

        if (shouldSetTheme && res.data.colorTheme !== themeMode) {
          setThemeMode(res.data.colorTheme);
        }
      });
  };

  // SuccessSnackbar
  const openSuccessSnackbar = (msg: string) => {
    setOpenSuccess(true);
    setMsgSuccess(msg);
  };

  const onCloseSuccessSnackbar = () => {
    setOpenSuccess(false);
  };

  // WarningSnackbar
  const openWarningSnackbar = (msg: string) => {
    setOpenWarning(true);
    setMsgWarning(msg);
  };

  const onCloseWarningSnackbar = () => {
    setOpenWarning(false);
  };

  // ErrorSnackbar
  const openErrorSnackbar = (msg: string) => {
    setOpenError(true);
    setMsgError(msg);
  };

  const onCloseErrorSnackbar = () => {
    setOpenError(false);
  };

  /*****************************************
   style
  ******************************************/
  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  // MuiPaper-root css
  const useStylesMuiPaper = makeStyles(() => ({
    root: {
      "&.MuiPaper-root,&.MuiPaper-elevation": {
        color: "#fff",
        backgroundcolor: "#121212",
      },
    },
  }));
  const classesMuiPaper = useStylesMuiPaper();

  // bodyのスタイルの上書き
  const useBodyStyles = makeStyles(() => ({
    body: {
      background: theme.palette.base.sub,
    },
  }));

  const classesBody = useBodyStyles();
  document.body.classList.add(classesBody.body);

  // const customButton = {
  //   background: theme.palette.primary.main,
  //   boxShadow: "none",
  //   "&:hover": {
  //     background: theme.palette.primary.main,
  //     boxShadow: "none",
  //   },
  // };

  // const CustomAlignmentIcon = () => {
  //   return (
  //     <div
  //       style={
  //         disabledAlignmentDialog() ? { ...customColor, opacity: 0.5 } : null
  //       }
  //     >
  //       <img src={AlignmentIcon} alt="" />
  //     </div>
  //   );
  // };

  // データロードエラー、エラー画面表示
  if (detailDataLoadingStatus === LoadingStatus.Error) {
    let resErrMsg: string = "Not Found";
    if (errorDetailsStatus === resErrCode.Authority) resErrMsg = "Not Allowed";
    return (
      <div>
        <h2
          style={{
            color: customColor.color,
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          {errorDetailsStatus} {resErrMsg}
        </h2>
        {displayType === EDisplayType.Web ? (
          <p style={{ color: "white", textAlign: "center" }}>
            <Link to="/">{t("BACK_TO_TOP")}</Link>
          </p>
        ) : (
          <></>
        )}
      </div>
    );
  }

  // データロード中、ローディング画面表示
  if (detailDataLoadingStatus === LoadingStatus.Loading) {
    return (
      <div>
        <CircularProgress
          sx={{ position: "absolute", left: "50%", top: "50%" }}
        />
        <MsgSnackbar
          open={openSuccess}
          onClose={onCloseSuccessSnackbar}
          msg={msgSuccess}
        />
        <MsgErrSnackbar
          open={openError}
          onClose={onCloseErrorSnackbar}
          msg={msgError}
        />
      </div>
    );
  }

  // const handleClickPhotoShown = () => {
  //   setDetailTab(PHOTOS as DETAIL_TAB);
  //   setProjectDetailPageView(EViewerMode.PHOTO);
  // };

  // const updateProjectionMode = (mode: TProjectionMode) => {
  //   setProjectionMode(mode);
  //   viewer.setProjectionMode(mode);
  // };

  return (
    <Box
      className={`${classesMuiPaper.root}`}
      sx={{
        height:
          displayType === EDisplayType.Web ? "calc(100vh - 42px)" : "100vh",
      }}
    >
      <ViewerContext.Provider value={viewer}>
        <ProjectDetailContext.Provider
          value={{
            projectDetail: projectDetail,
            getProjectDetail: getProjectDetail,
            userSettings: userSettings,
            updateProjectDetail: updateProjectDetail,
            displayType: displayType,
            viewer: viewer,
            currentPointCloud: currentPointCloud,
            updateCurrentPointCloud: updateCurrentPointCloud,
            currentViewerMode: currentViewerMode,
            updateCurrentViewerMode: updateCurrentViewerMode,
            isJapanese: isJapanese,
            whilePointCloudLoading: whilePointCloudLoading,
            updateWhilePointCloudLoading: updateWhilePointCloudLoading,
            isDialogType: currentDialog,
            updateCurrentDialog: updateCurrentDialog,
            detailTab,
            setDetailTab,
            openProjectState,
            setOpenProjectState,
            reloadPointCloud,
            isArView: isArView,
            isIosView: isIosView,
          }}
        >
          <PollingContext.Provider
            value={{
              processIds: processIds,
              updateProcessIds: updateProcessIds,
              callback: pollingCallback,
              setCallback: setPollingCallback,
            }}
          >
            <CoordinateContextProvider>
              <HelmContextProvider>
                <UpdateInfoContextProvider>
                  <CalcContextProvider>
                    <RemoveContextProvider>
                      <UseSnackbarContext.Provider
                        value={{
                          openSuccess: openSuccessSnackbar,
                          onCloseSuccess: onCloseSuccessSnackbar,
                          openWarning: openWarningSnackbar,
                          onCloseWarning: onCloseWarningSnackbar,
                          openError: openErrorSnackbar,
                          onCloseError: onCloseErrorSnackbar,
                        }}
                      >
                        {displayType === EDisplayType.Web ? (
                          <NavBar userInfo={userInfo} />
                        ) : (
                          <></>
                        )}
                        <MenuBar />
                        {detailTab !== DETAIL_TAB.PHOTO && (
                          <ToolBar
                            projectDetail={projectDetail}
                            currentViewerMode={currentViewerMode}
                          />
                        )}
                        <Box
                          sx={{
                            height: viewerHeight,
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            width: "100%",
                          }}
                        >
                          {detailTab !== DETAIL_TAB.PHOTO ? (
                            <PointCloudViewer ref={pointCloudViewerRef} />
                          ) : (
                            <Photos photoURLs={projectDetail.photoURLs} />
                          )}
                        </Box>
                        <Q3DBottomDrawer
                          type={currentViewerMode}
                          open={bottomOpen}
                          setOpen={() => {
                            setBottomOpen(!bottomOpen);
                          }}
                        />
                        <ProjectState
                          openProjectState={
                            openProjectState && detailTab !== DETAIL_TAB.PHOTO
                          }
                          toggleProjectState={toggleProjectState}
                          toolBarShow={toolBarShow}
                          pix4dErrorMessage={pix4dErrorMessage}
                          pix4dErrorCode={pix4dErrorCode}
                        />
                        {/* dialogs */}
                        <RegisterWithDashboard
                          open={
                            currentDialog ===
                            EDialogType.REGISTER_WITH_DASHBOARD
                          }
                          close={() => updateCurrentDialog(EDialogType.NONE)}
                        />
                        <RegisterWithLLV
                          open={currentDialog === EDialogType.REGISTER_WITH_LLV}
                          close={() => updateCurrentDialog(EDialogType.NONE)}
                        />
                        <RegisterWithPointworks
                          open={
                            currentDialog ===
                            EDialogType.REGISTER_WITH_POINTWORKS
                          }
                          close={() => updateCurrentDialog(EDialogType.NONE)}
                        />
                        <ExportData
                          open={currentDialog === EDialogType.EXPORT_DATA}
                          close={() => updateCurrentDialog(EDialogType.NONE)}
                        />
                        <ProjectDetailDialog
                          open={currentDialog === EDialogType.PROJECT_DETAIL}
                          close={() => updateCurrentDialog(EDialogType.NONE)}
                          setProjectName={setProjectName}
                          projectDetail={projectDetail}
                          updateProjectDetail={updateProjectDetail}
                        />
                        <SettingDialog
                          open={currentDialog === EDialogType.SETTING}
                          close={() => updateCurrentDialog(EDialogType.NONE)}
                          userId={userInfo?.userId}
                          isDetail={true}
                        />
                        <DeleteProjectDialog
                          openDialog={
                            currentDialog === EDialogType.PROJECT_DELETE
                          }
                          setOpenDialog={() =>
                            updateCurrentDialog(EDialogType.NONE)
                          }
                          projectID={projectDetail?.id}
                          projectName={projectDetail?.name}
                        />
                        <DeleteAllPointsDialog
                          open={currentDialog === EDialogType.DELETE_ALL_POINTS}
                          close={() => updateCurrentDialog(EDialogType.NONE)}
                        />
                        <ProcessCompletedDialog
                          open={openProcessCompletedDialog}
                          processResult={processResult}
                          handleClickClose={closeProcessCompletedDialog}
                        />
                        <MsgSnackbar
                          open={openSuccess}
                          onClose={onCloseSuccessSnackbar}
                          msg={msgSuccess}
                        />
                        <MsgErrSnackbar
                          open={openError}
                          onClose={onCloseErrorSnackbar}
                          msg={msgError}
                        />
                        <MsgWarnSnackbar
                          open={openWarnig}
                          onClose={onCloseWarningSnackbar}
                          msg={msgWarning}
                        />
                      </UseSnackbarContext.Provider>
                    </RemoveContextProvider>
                  </CalcContextProvider>
                </UpdateInfoContextProvider>
              </HelmContextProvider>
            </CoordinateContextProvider>
          </PollingContext.Provider>
        </ProjectDetailContext.Provider>
      </ViewerContext.Provider>
    </Box>
  );
};

export default ProjectDetail;
